import useGetter from "../useGetter";
import useSeason from "../useSeason";

export default function useNflTeams() {
  const season = useSeason();

  const { data: nflTeamsData, query: nflTeamsQuery } = useGetter(
    `/nfl/${season}/teams`,
    { enabled: !!season, staleTime: 30 * 24 * 60 * 60 * 1000 }
  );

  return { nflTeamsData, nflTeamsQuery };
}
